<template>
  <v-icon :data-testid="sectionTag" :icon="mdiInformation" class="info_icon"></v-icon>
</template>

<script setup lang="ts">
import { colors } from '@/plugins/vuetify'
import { mdiInformation } from '@mdi/js'
export interface IconInfoProps {
  sectionTag?: string
  size?: string
}

withDefaults(defineProps<IconInfoProps>(), {
  sectionTag: 'unspecified',
  size: '14px'
})


</script>

<style scoped>
.info_icon {
  color: v-bind('colors.neutral.neutral1000') !important;
  font-size: v-bind('size') !important;
}

.info_icon:hover {
  color: v-bind('colors.blue.blue600') !important;
}
</style>
